import { useState, useCallback } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { useMutation } from "@tanstack/react-query";
import { resendVerificationApi } from "../model/authApi";
import { toastService } from "@/shared/toast";

/**
 * EmailVerificationPending ViewModel
 * Manages state and business logic for the resend verification flow
 */
export const useEmailVerificationPendingViewModel = () => {
  const location = useLocation();
  const navigate = useNavigate();
  const state = (location.state || {}) as { email?: string; from?: string };
  const from = state.from;

  const [email, setEmail] = useState(state.email || "");

  const goToLogin = useCallback(() => {
    navigate("/login", {
      state: { from },
    });
  }, [navigate, from]);

  const BUTTON_ID = "resend-verification-button";

  const mutation = useMutation({
    mutationFn: (emailToUse: string) => resendVerificationApi(emailToUse, "inline", BUTTON_ID),
    onSuccess: () => {
      toastService.show("Verification email has been resent. Please check your inbox.", "success");
    },
  });

  const updateEmail = useCallback((value: string) => {
    setEmail(value);
  }, []);

  const handleResend = useCallback(
    (e: React.FormEvent) => {
      e.preventDefault();
      if (!email) {
        toastService.show("Please enter your email address.", "error");
        return;
      }
      mutation.mutate(email);
    },
    [email, mutation]
  );

  return {
    email,
    isLoading: mutation.isPending,
    updateEmail,
    handleResend,
    goToLogin,
  };
};
